import { helper } from '@ember/component/helper';

export default helper(function toPercentageString(positional /*, named*/) {
  return Math.round(positional * 100) + '%';
});
